import React, { FC } from 'react';
import { Tabs, Tab } from '@mui/material';
import './CustomTab.scss';
import { useTranslation } from 'react-i18next';

interface TabPanelProps {
  orientation?: 'horizontal' | 'vertical';
  tabValue: number;
  setTabValue: (event: React.SyntheticEvent, newValue: number) => void;
  tabs: TabElement[];
  clickTabValue?: (id: number) => void;
  isAutoPayAvailable?: boolean;
}

interface TabElement {
  label: string;
  id: number;
}

const defaultProps = {
  orientation: undefined,
  clickTabValue: undefined,
  isAutoPayAvailable: false,
};

export const CustomTab: FC<TabPanelProps> = ({
  orientation,
  tabs,
  tabValue,
  setTabValue,
  clickTabValue,
  isAutoPayAvailable,
}) => {
  const { t } = useTranslation();
  return (
    <div className="custom-tabs">
      <Tabs
        orientation={orientation}
        value={tabValue}
        onChange={setTabValue}
        className={orientation === 'horizontal' ? 'custom-tabs__horizontal' : 'custom-tabs__vertical'}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {tabs.map((tab) => {
          return (
            <Tab
              key={tab.id}
              label={tab.label}
              onClick={clickTabValue ? () => clickTabValue(tab.id) : undefined}
              id={`vertical-tab-${tab.id}`}
              aria-controls={`vertical-tabpanel-${tab.id}`}
              disabled={isAutoPayAvailable && tab.label === t('accountSettings.regularPayment')}
            />
          );
        })}
      </Tabs>
    </div>
  );
};

CustomTab.defaultProps = defaultProps;
